// components/GoogleLoginButton.jsx
'use client';

import { c as _c } from "react/compiler-runtime";
import UIButton from '../atoms/UIButtons/UIButton';
function LoginButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const params = new URLSearchParams({
      client_id: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
      redirect_uri: `${process.env.NEXT_PUBLIC_GOOGLE_REDIRECT_URI}`,
      response_type: "code",
      scope: "email",
      access_type: "offline",
      prompt: "consent"
    });
    console.log(params.toString());
    t0 = <UIButton href={`https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`} className="mx-auto max-w-[343px] w-full block" rounded="full" variant="outline">Sign in with Google</UIButton>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export default function GoogleLoginButton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <LoginButton />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}